import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ReturnToTop from "../components/ReturnToTop";

export default function RootLayout() {
    return (
        <>
            <Header />
            {/* <main> */}
                <div className="ss-inner overflow-hidden">
                    <Outlet />
                </div>
            {/* </main> */}
            <Footer />
            <ReturnToTop/>
        </>
    )
}